import classes from "./DotBall.module.css"
import clsx from "clsx"
const  DotBall = ({bookingStatus,width="6px",height="6px"}) => {
    return (
        <span
        style={{width,height}}
        className={clsx(classes.ball, {
          [classes.confirm]: bookingStatus === 1,
          [classes.pending]: bookingStatus === 3,
          [classes.cancelled]: bookingStatus === 2,
        })}
      />
    )
}

export default DotBall;
